// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"_3Jr_V","effectsGrayscale30":"_2rcil","resetList":"_7b57s","shake":"-QWkm"};